angular
  .module('slf')
  .filter('notEmpty', function () {
    return function (answers) {
      return answers.filter(function (answer) {
        return answer.value !== null && answer.value !== '';
      });
    };
  });
